<template>
    <div
        class="flex items-center h-20 gap-3 px-4 py-4 border-b border-slate-200 dark:border-slate-700 last:border-b-0 hover:bg-slate-50 dark:hover:bg-slate-700 active:bg-slate-100 dark:active:bg-slate-700 transition-colors duration-150 cursor-pointer"
    >
        <!-- Logo -->
        <div class="w-14 h-10 flex items-center justify-center shrink-0">
            <img
                v-if="partner.program_image && !imageError[partner.id]"
                :src="`${cdnUrl}/${partner.program_image.path}/_small/${partner.program_image.file_name}`"
                :alt="partner.name"
                class="max-w-full max-h-full object-contain"
                @error="$emit('image-error', partner.id)"
            />
            <div
                v-else
                class="w-14 h-10 bg-gray-100 dark:bg-slate-700 border border-gray-200 dark:border-slate-700 rounded flex items-center justify-center"
            >
                <span
                    class="text-[10px] font-medium text-gray-500 dark:text-gray-400 text-center px-1"
                >
                    {{ partner.name.slice(0, 10) }}
                </span>
            </div>
        </div>

        <!-- Texts -->
        <div class="flex-1 min-w-0" @click="$emit('navigate', partner)">
            <div
                class="text-slate-800 dark:text-slate-100 text-sm font-medium leading-5 truncate"
            >
                {{ partner.name }}
            </div>
            <div class="text-slate-500 dark:text-slate-400 text-xs leading-4">
                {{ formatProgramType(partner.type) }}
            </div>
        </div>

        <!-- Actions -->
        <div class="flex items-center gap-1">
            <Icon
                v-if="
                    alertsFeatureEnabled &&
                    alertsEnabledProgramIds.includes(partner.id)
                "
                icon="bell-added-color"
                class="w-5 h-5 text-slate-500 dark:text-slate-400"
                aria-hidden="true"
            />
            <div class="relative">
                <button
                    @click.stop="$emit('toggle-favorite', partner)"
                    class="transition-colors duration-200 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-2 rounded"
                    aria-label="Toggle favorite"
                >
                    <Icon
                        :icon="partner.is_favorite ? 'heart' : 'unfavorited'"
                        :class="[
                            'w-5 h-5 transition-colors duration-200',
                            partner.is_favorite
                                ? 'text-red-500 hover:text-red-400'
                                : 'text-slate-400 hover:text-orange',
                        ]"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';

const cdnUrl = window.cdnUrl;

defineProps({
    partner: { type: Object, required: true },
    alertsFeatureEnabled: { type: Boolean, default: false },
    alertsEnabledProgramIds: { type: Array, default: () => [] },
    imageError: { type: Object, default: () => ({}) },
    formatProgramType: { type: Function, required: true },
});

defineEmits(['toggle-favorite', 'navigate', 'image-error']);
</script>
